import React, { useEffect, useState } from "react";
import TableHeading from "../../../Components/common/table/Tableheading";
import { showData } from "../../../Utils/APIs/commonShowAPI";
import { insertData } from "../../../Utils/APIs/commonInsertAPI";
import { getCookie } from "../../../Utils/cookies";
import { MdOutlineDoneAll } from "react-icons/md";
import { MdOutlineTravelExplore, MdChevronLeft, MdChevronRight } from "react-icons/md";
import { FaPencil } from "react-icons/fa6";
import NormalInput from "../../../Components/common/input/NormalInput";
import NormalButton from "../../../Components/common/button/NormalButton";
import axios from "axios";

const ConsignmentList = ({ coordinatesSetter }) => {

  const [consignmentList, setConsignmentList] = useState([]);
  const [punchOut, setPunchOut] = useState(false);
  const [deleteResponse, setDeleteResponse] = useState(false);
  const [paymentApprovedResponse, setPaymentApprovedResponse] = useState([]);
  const [updatedConsignmentId, setUpdatedConsignmentId] = useState(null);
  const [isOpenUpdatePanel, setIsOpenUpdatePanel] = useState(false);
  const [newMapReading, setNewMapReading] = useState("");
  const [newMeterReading, setNewMeterReading] = useState("");
  const [newRemark, setNewRemark] = useState("");
  const [initialMeterImage, setInitialMeterImage] = useState(null);
  const [finalMeterImage, setFinalMeterImage] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  useEffect(() => {
    const fetchData = async () => {
      setConsignmentList([]);
      await showData(`track/consignmentList?page=${page<1 ? 1 : page}&limit=${limit}`, setConsignmentList);
    };
    fetchData();
    setPunchOut(false);
    setDeleteResponse(false);
  }, [punchOut, deleteResponse, paymentApprovedResponse, page]);

  const HeadingList = [
    "SR No",
    "Vehicle No",
    "Source Location",
    "Destination Location",
    "Map",
    "Travel Date",
    "Travel Distance",
    "Status",
    "#",
    "#",
    "#",
    "Payment",
    "Update Meter",
  ];
  const handlePunchOut = async (vehicleId) => {
    const response = await insertData(
      `track/vehiclePunchOut/${vehicleId}`,
      setPunchOut,
      {}
    );
    if (response) {
      alert("Punch Out Successfully");
    } else {
      alert(punchOut || "Something went wrong");
    }
  };
  const handlePunchIn = async (vehicleId) => {
    const response = await insertData(
      `track/vehiclePunchIn/${vehicleId}`,
      setPunchOut,
      {}
    );
    if (response) {
      alert("Punch In Successfully");
    } else {
      alert(punchOut || "Something went wrong");
    }
  };
  const deleteConsignment = async (id) => {
    await insertData("track/blockConsignment", setDeleteResponse, {
      consignmentId: id,
    });
    if (deleteResponse.status === 200) {
      alert("Consignment Deleted Successfully");
    } else {
      alert("delete", deleteResponse?.data?.message);
    }
  };

  const paymentApproved = async (id) => {
    await insertData("track/paymentApproved", setPaymentApprovedResponse, {
      consignmentId: id,
    }).then(() => {
      if (paymentApprovedResponse) {
        alert(paymentApprovedResponse);
      } else {
        alert(paymentApprovedResponse);
      }
    });
  };

  const fetchCoordinates = async (consignmentId) => {
    if (!consignmentId) {
      alert("Try again");
    } else {
      await showData(
        `track/showConsignmentTravelHistory?consignmentId=${consignmentId}`,
        coordinatesSetter
      ).then((response) => {
        if (!response) {
          alert("No Location save.");
        }
      });
    }
  };
  const requestMeterUpdate = async() => {
    if (!newMapReading || !newMeterReading || !initialMeterImage || !finalMeterImage) {
      alert("Please fill all the fields");
      return;
    }
    const formData = new FormData();
    formData.append("updatedConsignmentId", updatedConsignmentId);
    formData.append("newMapReading", newMapReading);
    formData.append("newMeterReading", newMeterReading);
    formData.append("initialMeterImage", initialMeterImage);
    formData.append("finalMeterImage", finalMeterImage);
    formData.append("remark", newRemark);
    
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/track/requestMeterUpdate`, formData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => {
      if (response.status === 201) {
        alert( response?.data?.message || "Meter update request sent successfully");  
        setNewMapReading("");
        setNewMeterReading("");
        setInitialMeterImage(null);
        setFinalMeterImage(null);
      }
      else {
        alert(response?.data?.message ||  "Failed to send meter update request");
      }
    });
    } catch (error) {
        alert(error?.response?.data?.message ||"Error submitting the request");
    }
    setIsOpenUpdatePanel(false);
  };
  return (
    <div className="w-full overflow-x-auto h-[calc(100vh-11rem)] justify-items-start">
      <table className="w-full text-sm text-center text-gray-500 border-gray-700 overflow-scroll">
        <TableHeading list={HeadingList} />
        <tbody className="text-sm text-gray-500">
          {consignmentList?.map((item, index) => (
            <tr key={index} className="bg-white border-b hover:bg-gray-50 ">
              <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                {++index + (page * limit) - limit}
              </td>
              <td className="px-6 py-4">
                {item?.vehicleData?.[0]?.vehicleNumber}
              </td>
              <td className="bg-white px-6 py-4 text max-w-[200px] truncate hover:overflow-visible hover:whitespace-normal hover:bg-white relative group">
                <div className="absolute flex items-center inset-0 w-full h-full overflow-hidden truncate group-hover:whitespace-normal group-hover:overflow-visible">
                  {item?.srcAddress}
                </div>
              </td>
              <td className="bg-white px-6 py-4 text max-w-[200px] truncate hover:overflow-visible hover:whitespace-normal hover:bg-black relative group">
                <div className="absolute flex items-center justify-center inset-0 w-full h-full overflow-hidden truncate group-hover:whitespace-normal group-hover:overflow-visible">
                  {item?.deliveryAddress}
                </div>
              </td>
              <td
                className="px-6 py-4 flex justify-center items-center"
                onClick={() => fetchCoordinates(item?._id)}
              >
                <MdOutlineTravelExplore
                  color="blue"
                  size={20}
                  className="mx-auto"
                />
              </td>
              <td className="px-6 py-4 text-nowrap">
                {item?.punchData?.[0]?.punchDate?.split("T")[0]}
              </td>
              <td className="px-6 py-4">
                {item?.punchData?.punchOut?.[0]?.length === 0
                  ? "-"
                  : (item?.punchData?.[0]?.updatedDistance || (item?.punchData?.[0]?.finalDistance -
                    item?.punchData?.[0]?.initialDistance)) + " km"}
              </td>
              <td className="px-6 py-4 text-nowrap">
                {item?.punchData?.[0]?.punchIn?.length === 0
                  ? "Pending"
                  : item?.punchData?.[0]?.punchOut.length === 0
                  ? "Running"
                  : "Delivery Done"}
              </td>
              <td
                className="px-6 py-4 text-blue-600 text-nowrap hover:cursor-pointer"
                onClick={() => {
                  if (!item?.punchData?.[0]?.punchIn?.length) {
                    handlePunchIn(item?._id);
                  } else {
                    alert("Already Punch In");
                  }
                }}
              >
                {!item?.punchData?.[0]?.punchIn?.length ? "Punch-In" : "-"}
              </td>
              <td
                className="px-6 py-4 text-green-600 text-nowrap hover:cursor-pointer"
                onClick={() => {
                  if (item?.punchData?.[0]?.punchOut.length === 0) {
                    handlePunchOut(item?._id);
                  } else {
                    alert("Already Punch Out");
                  }
                }}
              >
                {!item?.punchData?.[0]?.punchOut.length ? "Punch-Out" : "-"}
              </td>
              <td
                className="px-6 py-4 text-red-600 hover:cursor-pointer text-nowrap"
                onClick={() => deleteConsignment(item?._id)}
              >
                Delete
              </td>
              {!item?.payment && !item?.paymentApprovedByAccount ? (
                  item?.paymentApprovedByAdmin ?
                  <td className="px-6 py-4 text-blue-500 text-center">
                    Approved By Admin
                  </td> :
                  (item?.paymentRequest ? 
                    <td className="px-6 py-4 text-blue-500 text-center">
                    Pending By Admin
                  </td>
                  :<td className="px-6 py-4 text-blue-500 text-center">
                    Pending
                  </td>)
              ) : (
                <td className="px-6 py-4 text-green-400 text-center">
                  <MdOutlineDoneAll className="mx-auto" />
                </td>
              )}
              <td>
                {item?.punchData?.[0]?.punchOut.length !== 0 &&
                  item?.punchData?.[0]?.punchIn.length !== 0 &&
                  !item?.payment && !item?.paymentApprovedByAdmin &&
                  !item?.paymentApprovedByAccount && (
                    <button
                      className=" text-blue-600 rounded"
                      onClick={() => {
                        setUpdatedConsignmentId(item?._id);
                        setIsOpenUpdatePanel(true)}}
                    >
                      <FaPencil size={16} />
                    </button>
                  )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {consignmentList?.length === 0 && (
        <div className="w-full h-[60vh] flex justify-center items-center">
          <h1 className="text-gray-400 text-2xl">Loading. . . .</h1>
        </div>
      )}
      {isOpenUpdatePanel && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg relative w-[400px]">
            {/* Close Button (Top Right) */}
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-black"
              onClick={(e) => setIsOpenUpdatePanel(false)}
            >
              ✖
            </button>
            <h2 className="text-xl font-semibold mb-4">
              Request Update Meter Reading
            </h2>
            <p className="mb-4 text-xs text-gray-400">
              To update the meter reading, please contact the fleet manager or
              use the designated update panel in the application.
            </p>
              <NormalInput 
                label="Map Reading"
                value={newMapReading}
                setterFun={setNewMapReading}
                isRequired={true}
                placeholder="Enter the new map reading"
              />
              <NormalInput 
                label="Meter Reading"
                value={newMeterReading}
                setterFun={setNewMeterReading}
                isRequired={true}
                placeholder="Enter the new meter reading"
              />
              <NormalInput 
                label="Starting Meter Reading"
                value={initialMeterImage}
                setterFun={setInitialMeterImage}
                isRequired={true}
                placeholder={null}
                type="file"
              />
              <NormalInput 
                label="End Meter Reading"
                value={finalMeterImage}
                setterFun={setFinalMeterImage}
                isRequired={true}
                placeholder={null}
                type="file"
              />
              <NormalInput 
                label="Remark"
                value={newRemark}
                setterFun={setNewRemark}
                placeholder="Something about the update request"
              /> 
              <div className="mt-4 flex justify-end">
                <NormalButton 
                  btnName="Submit Request"
                  onClickFun={requestMeterUpdate}
                />
              </div>
          </div>
        </div>
      )}
      <div className="fixed bottom-0">
        {page > 1 && <button onClick={()=> setPage(prev => --prev)} className="bg-yellow-500 p-2 text-white rounded-xs mr-6"><MdChevronLeft size={28} /></button>}
        <button onClick={()=> setPage(prev => ++prev)}  className="bg-yellow-500 p-2 text-white rounded-xs"><MdChevronRight size={28}/></button>
      </div>
    </div>
  );
};

export default ConsignmentList;